<dx-popup
  width="auto"
  height="auto"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [wrapperAttr]="{ class: 'produit-complementaire-periode-popup' }"
  (onShowing)="onShowing()"
  [(visible)]="visible">

  <div *dxTemplate="let _ of 'title'" class="periode-conditionnement-header">
    <div>
      <yo-icon icon="calendar"></yo-icon> <strong> Périodes de conditionnement</strong>
    </div>

    <div class="periode-conditionnement-header-actions">
      <yo-button
        iconClass="fas fa-check"
        tooltip="Appliquer"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="appliquer()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="fermer()">
      </yo-button>
    </div>
  </div>

  <section class="periode-conditionnement-content">

    <div class="periode-conditionnement-column">
      <span class="periode-conditionnement-section-title">
        <strong>Nouvelle période</strong>
      </span>

      <div class="periode-conditionnement-list periode-conditionnement-form">
        <div class="periode-conditionnement-produit" [title]="paramSvc.getNatureLibelle(produit())">
          <yo-icon [icon]="paramSvc.getNatureIcon(produit())" [theme]="paramSvc.getNatureTheme(produit())" cssClass="mg-r-5"></yo-icon>
          <span>{{ paramSvc.getProduitLibelle(produit()) }}</span>
        </div>

        <div class="periode-conditionnement-row">
          <span>À partir de <span class="danger-color">*</span></span>
          <yo-date-picker
            [value]="dateDebut"
            (onValueChange)="onDateDebutChange($event)">
          </yo-date-picker>
        </div>

        <div class="periode-conditionnement-row">
          <span>Unité de commande <span class="danger-color">*</span></span>
          <yo-lookup
            [data]="uniteDeCommandeList()"
            [selectedItem]="uniteId"
            [displayValue]="paramSvc.getUniteDeCommandeItemLibelle"
            autoSelect="false"
            placeholder="Sélectionner l'unité de commande ..."
            (onValueChange)="onUniteDeCommandeChange($event)">
          </yo-lookup>
        </div>

        <div class="periode-conditionnement-row">
          <span>Ratio <span class="danger-color">*</span></span>
          <div class="periode-conditionnement-ratio">
            <dx-number-box
              [(value)]="ratio"
              [min]="0"
              placeholder="Ratio">
            </dx-number-box>
            <strong>{{ paramSvc.getUniteTechniqueAbreviation(produit()) }}</strong>
          </div>
        </div>

        <div class="periode-conditionnement-row-actions">
          <yo-button
            label="AJOUTER LA PÉRIODE"
            iconClass="fas fa-plus"
            [theme]="ButtonThemeEnum.ADD"
            (onClick)="ajouterPeriode()">
          </yo-button>
        </div>
      </div>
    </div>

    <div class="periode-conditionnement-column">
      <span class="periode-conditionnement-section-title">
        <strong>Périodes définies</strong>
      </span>

      <div class="periode-conditionnement-list">
        <table class="periode-conditionnement-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Date</th>
              <th>Unité commandable</th>
              <th>Ratio</th>
              <th>UT</th>
            </tr>
          </thead>
          <tbody>
            @for (periode of periodeList(); track periode.dateDebut) {
              <tr>
                <td>
                  <yo-button
                    size="small"
                    iconClass="fas fa-trash"
                    [theme]="ButtonThemeEnum.DELETE_INNER"
                    tooltip="Supprimer la période"
                    (onClick)="supprimerPeriode(periode.dateDebut)">
                  </yo-button>
                </td>
                <td>{{ periode.dateDebut | date: 'dd/MM/yyyy' }}</td>
                <td>{{ paramSvc.getPeriodeUniteLibelle(produit(), periode) }}</td>
                <td>{{ paramSvc.getPeriodeRatio(periode) }}</td>
                <td>{{ paramSvc.getUniteTechniqueAbreviation(produit()) }}</td>
              </tr>
            } @empty {
              <tr>
                <td class="periode-conditionnement-vide" colspan="5">Aucune période de conditionnement définie</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </section>
</dx-popup>
